import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/providers/RQProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/providers/WDYRProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/bridge/BridgeDataPanel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/bridge/ColorThemeHandler.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/bridge/NativeBackHandler.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/core/NewRelicScript.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/providers/FirebaseProvider.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/styles/globals.scss");
